/**
 * Licensed states for the Wholesale channel. The original page ships two lists
 * (investment properties are available in more states) plus a 22 MB inline table
 * of every US ZIP code, used only to pick a representative ZIP per state — that
 * table is condensed here to the one lookup the page actually performs.
 */

const NAMES = {
    AK: 'Alaska', AL: 'Alabama', AR: 'Arkansas', AZ: 'Arizona', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia', DE: 'Delaware',
    FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois',
    IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts',
    MD: 'Maryland', ME: 'Maine', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri',
    MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina', NE: 'Nebraska',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NV: 'Nevada', NY: 'New York',
    OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
    SC: 'South Carolina', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia',
    VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming',
};

/** Owner-occupied / second home. */
const WHOLESALE = [
    'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN',
    'MD', 'ME', 'MI', 'MN', 'MT', 'NC', 'NJ', 'NV', 'OH', 'OK', 'OR', 'PA', 'RI',
    'SC', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI',
];

/** Investment occupancy opens up the remaining states. */
const WHOLESALE_INVESTMENT = [
    'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA',
    'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS',
    'MT', 'NC', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI',
    'SC', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY',
];

/** Correspondent is licensed in a slightly different owner-occupied set. */
const CORRESPONDENT = [
    'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL',
    'IN', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MT', 'NC', 'NJ', 'NV', 'OH', 'OK',
    'OR', 'PA', 'RI', 'SC', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI',
];

/** Investment opens up the same full list on both channels. */
const CORRESPONDENT_INVESTMENT = WHOLESALE_INVESTMENT;

const toOptions = (codes) => codes.map((c) => ({ value: c, label: `${NAMES[c]} [${c}]` }));

const OPTIONS = {
    wholesale: toOptions(WHOLESALE),
    wholesaleInvestment: toOptions(WHOLESALE_INVESTMENT),
    correspondent: toOptions(CORRESPONDENT),
    correspondentInvestment: toOptions(CORRESPONDENT_INVESTMENT),
};

/** Occupancy "2" is Investment. */
export function stateOptions(occupancy, correspondent = false) {
    const investment = occupancy === '2';
    if (correspondent) return investment ? OPTIONS.correspondentInvestment : OPTIONS.correspondent;
    return investment ? OPTIONS.wholesaleInvestment : OPTIONS.wholesale;
}
